import { motion } from "framer-motion";
import LucideIcon from "utils/LucideIcon";

const OurExperties = () => {
  const missionCards = [
    {
      icon: <LucideIcon name="HeartHandshake" size={18} className="text-pink-500 hover:text-pink-500" />,
      title: "Customer First",
      description:
        "We prioritize every client's needs, ensuring trust, satisfaction, and long-term meaningful relationships.",
      color: "bg-pink-50 border-pink-200", // Pink symbolizes care & empathy
    },
    {
      icon: <LucideIcon name="Lightbulb" size={18} className="text-orange-500 hover:text-orange-500" />,
      title: "Creative Excellence",
      description:
        "We bring fresh ideas and unique solutions that reflect each brand's distinct personality.",
      color: "bg-orange-50 border-orange-200", // Orange suggests creativity & enthusiasm
    },
    {
      icon: <LucideIcon name="ShieldCheck" size={18} className="text-teal-600 hover:text-teal-600" />,
      title: "Reliable Quality",
      description:
        "Every detail matters. We deliver consistently with care, precision, and high production standards.",
      color: "bg-teal-50 border-teal-200", // Teal reflects trust & clarity
    },
    {
      icon: <LucideIcon name="Goal" size={18} className="text-indigo-500 hover:text-indigo-500" />,
      title: "Ownership Mindset",
      description:
        "We take initiative, stay accountable, and treat every task as if the business is ours.",
      color: "bg-indigo-50 border-indigo-200", // Indigo signals responsibility & leadership
    },
  ];


  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.4,
        ease: "easeOut" as const,
      },
    },
    hover: {
      y: -5,
      transition: {
        duration: 0.2,
        ease: "easeInOut" as const,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut" as const,
      },
    },
  };

  return (
    <>
      <section className="py-20 px-4">
        <motion.h2
          variants={itemVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <div className="flex items-center md:text-left justify-center md:justify-start mb-4">
            {/* <BadgeCheck className="w-10 h-10 text-blue-900 mr-3 hidden md:inline-block" /> */}
            <LucideIcon
              name="BadgeCheck"
              className="w-10 h-10 text-blue-900 hover:text-blue-900 hidden md:inline-block mr-3"
            />
            <h2 className="text-4xl md:text-5xl font-bold font-inter text-secondary-gradient bg-clip-text text-transparent">
              Our Values
            </h2>
          </div>
        </motion.h2>
        <motion.div
          className="w-24 h-1 bg-secondary-gradient mx-auto md:mx-0 md:ml-14 mb-8 rounded-xl"
          initial={{ width: 0 }}
          whileInView={{ width: 96 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ amount: 0.2 }}
        ></motion.div>
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-8"
          variants={containerVariants}
        >
          {missionCards.map((card, index) => (
            <motion.div
              key={index}
              className={`${card.color} rounded-2xl p-8 border-2 shadow-lg hover:shadow-xl transition-all duration-300 backdrop-blur-sm`}
              variants={cardVariants}
              whileHover="hover"
            >
              <div className="flex items-start space-x-4">
                <motion.div
                  className="flex-shrink-0 p-3 bg-white rounded-xl shadow-md"
                  whileHover={{ scale: 1.2 }}
                  transition={{ duration: 0.5 }}
                >
                  {card.icon}
                </motion.div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3 font-comfortaa">
                    {card.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed font-inter">
                    {card.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section>
    </>
  );
};

export default OurExperties;
